import WEBAPI from '../../services/WEBAPI';
import { getAuthorityForCurrentApplication } from '../../services/platformCheck';
import * as ATypes from '../../shared/actionTypes';

export const getCalendar = (id) => {
  return (dispatch, getState) => {
    const authority =
      getAuthorityForCurrentApplication() ??
      getState()?.profileReducer?.profile?.authority?.name;

    dispatch({
      type: ATypes.GET_CALENDAR_REQ,
    });

    return WEBAPI.getCalendar(authority).then((res) => {
      dispatch({
        type: ATypes.GET_CALENDAR_RES,
        payload: res.result.data || [],
      });
    });
  };
};

const getCalendarRequest = () => ({
  type: ATypes.GET_CALENDAR_EVENT_REQ,
});

const getCalendarEventSuccess = (event) => ({
  type: ATypes.GET_CALENDAR_EVENT_RES,
  payload: event,
});

const getCalendarEventFailure = (error) => ({
  type: ATypes.GET_CALENDAR_EVENT_FAIL,
  payload: error,
});

export const getCalendarEvent = (id) => async (dispatch, getState) => {
  dispatch(getCalendarRequest());
  const authority =
    getAuthorityForCurrentApplication() ??
    getState()?.profileReducer?.profile?.authority?.name;

  try {
    const response = await WEBAPI.getCalendarEventByIdRequest(authority, id);
    console.log(response);

    if (response?.error) {
      throw new Error('Failed to load calendar item details. Try again later.');
    }

    const calendarEvent = response?.result?.data[0] ?? {};
    dispatch(getCalendarEventSuccess(calendarEvent));
  } catch (error) {
    dispatch(getCalendarEventFailure(error));
  }
};

export const postAttendEventSuccess = (response) => ({
  type: ATypes.POST_ATTEND_EVENT_SUCCESS,
  payload: response,
});

export const postAttendEventFailure = (error) => ({
  type: ATypes.POST_ATTEND_EVENT_ERROR,
  payload: error,
});

export const postAttendEventLoading = (isLoading) => ({
  type: ATypes.POST_ATTEND_EVENT_LOADING,
  payload: isLoading,
});

export const postAttendEvent =
  (authority, id) => async (dispatch, getState) => {
    const authority_name =
      (getAuthorityForCurrentApplication() ??
        getState()?.profileReducer?.profile?.authority?.name) ||
      authority;

    try {
      dispatch(postAttendEventLoading(true));

      const requestPayload = {
        authority_name,
        action_type: 'attend',
      };

      const response = await WEBAPI.postCalendarEventRequest(
        authority_name,
        requestPayload,
        id
      );

      if (response?.error) {
        throw new Error('Failed to post attendance. Try again later.');
      }

      dispatch(postAttendEventSuccess(response));
      dispatch(postAttendEventLoading(false));
    } catch (error) {
      console.error('Error posting attendance:', error);
      throw new Error('Failed to post attendance. Try again later.');
    }
  };

export const postRatingSuccess = (response) => ({
  type: ATypes.POST_RATING_SUCCESS,
  payload: response,
});

export const postRatingFailure = (error) => ({
  type: ATypes.POST_RATING_ERROR,
  payload: error,
});

export const postRatingLoading = (isLoading) => ({
  type: ATypes.POST_RATING_LOADING,
  payload: isLoading,
});

export const postRating =
  (authority, id, rating) => async (dispatch, getState) => {
    const authority_name =
      (getAuthorityForCurrentApplication() ??
        getState()?.profileReducer?.profile?.authority?.name) ||
      authority;

    try {
      dispatch(postRatingLoading(true));

      const requestPayload = {
        authority_name,
        action_type: 'rate',
        meta: {
          rate_value: rating > 0 ? rating : 0,
        },
      };

      const response = await WEBAPI.postCalendarEventRequest(
        authority_name,
        requestPayload,
        id
      );

      if (response?.error) {
        throw new Error('Failed to post rating. Try again later.');
      }

      dispatch(postRatingSuccess(response));
      dispatch(postRatingLoading(false));
    } catch (error) {
      console.error('Error posting rating:', error);
      throw new Error('Failed to post rating. Try again later.');
    }
  };
